// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2V2Wg","image":"Header_image__2nHKB","name":"Header_name__2ihY8","info":"Header_info__RKOa9","infoRow":"Header_infoRow__EDOnt"};